import type { RichTextTextAnimation } from "@library-elements/text";
import {
  removeTextAnimationAttrs,
  setTextAnimationAttrs,
} from "../../../utils/textAnimation";
import type { FroalaEditorInstance } from "../types";

export const handleTextAnimation = (
  editor: FroalaEditorInstance,
  data: RichTextTextAnimation | null,
  refresh: () => void,
) => {
  if (!editor.selection) return;
  const blocks = editor.selection.blocks() as HTMLElement[];
  for (const block of Array.from(blocks)) {
    if (data) {
      setTextAnimationAttrs(block, data);
    } else {
      removeTextAnimationAttrs(block);
    }
  }
  editor.save.save();
  refresh();
};
